import { useSubscription } from '../context/SubscriptionContext';
import { Link } from 'react-router-dom';
import { Clock, AlertTriangle } from 'lucide-react';

export default function TrialBanner() {
  const { subscription } = useSubscription();
  if (!subscription) return null;

  if (subscription.status === 'trial') {
    const days = subscription.trial_remaining_days;
    const urgent = days !== null && days <= 2;
    return (
      <div className="flex items-center justify-between px-6 py-2.5 font-body text-sm" style={{
        background: urgent ? 'rgba(200,75,49,0.08)' : 'rgba(10,54,34,0.06)',
        borderBottom: '1px solid #E5E3DB',
      }} data-testid="trial-banner">
        <div className="flex items-center gap-2">
          <Clock size={14} style={{ color: urgent ? '#C84B31' : '#D98A4A' }} />
          <span style={{ color: '#1A1A1A' }}>
            <strong>{days}</strong> day{days !== 1 ? 's' : ''} left in your free trial
          </span>
        </div>
        <Link to="/pricing" className="font-medium px-4 py-1 rounded-lg text-xs text-white transition-colors" style={{ background: '#0A3622' }} data-testid="upgrade-now-link">
          Upgrade Now
        </Link>
      </div>
    );
  }

  if (subscription.status === 'expired') {
    return (
      <div className="flex items-center justify-between px-6 py-2.5 font-body text-sm" style={{
        background: 'rgba(200,75,49,0.06)',
        borderBottom: '1px solid #E5E3DB',
      }} data-testid="expired-banner">
        <div className="flex items-center gap-2">
          <AlertTriangle size={14} style={{ color: '#C84B31' }} />
          <span style={{ color: '#C84B31' }}>Your trial has expired. Upgrade to continue using all features.</span>
        </div>
        <Link to="/pricing" className="font-medium px-4 py-1 rounded-full text-xs text-white transition-colors" style={{ background: '#C84B31' }} data-testid="upgrade-expired-link">
          Upgrade Now
        </Link>
      </div>
    );
  }

  return null;
}
